export default {
  TITLE: 'Cookies Policy',
  CONTENT: `
    <h3>Last Updated: October 1, 2020</h3>
    <p>
      We use cookies, pixels, and other technologies (collectively, "cookies") to recognize your browser or device, learn about your interests, and provide you with essential features and services and for additional purposes, including:
    </p>
    <ul class="number-format">
      <li>
        To recognize you when you sign-in to use our services. This allows us to provide you with product recommendations, display personalized content, recognize you as a Prime member, enable you to use 1-Click purchasing, and provide other customized features and services.
      </li>
      <li>
        To keep track of your specified preferences. This allows us to honor your likes and dislikes, such as whether or not you would like to see interest-based ads. You can set your preferences through <a data-path="adPreference">My Account</a>.
      </li>
      <li>Keep track of items stored in your shopping cart.</li>
      <li>Conduct research and diagnostics to improve Amazon's content, products, and services.</li>
      <li>Prevent fraudulent activity.</li>
      <li>Improve security.</li>
      <li>
        Deliver content, including ads, relevant to your interests on Amazon sites and third-party sites (see <a data-path="adPreference">Interest-Based Ads Notice</a> for how we use cookies to deliver interest-based ads).
      </li>
      <li>Reporting. This allows us to measure and analyze the performance of our services.</li>
    </ul>
    <p>
      Amazon's cookies allow you to take advantage of some of Amazon's essential features. For instance, if you block or otherwise reject our cookies, you will not be able to add items to your shopping cart, proceed to checkout, or use any Amazon products and services that require you to sign in.
    </p>
    <p>
      When you interact with Amazon services, authorized third parties may also set cookies. Third parties include search engines, providers of measurement and analytics services, social media networks, and advertising companies. Third parties use cookies in the process of delivering content, including ads relevant to your interests, to measure the effectiveness of their ads, and to perform services on behalf of Amazon.
    </p>
    <p>
      You can manage browser cookies through your browser settings. The "Help" feature on most browsers will tell you how to stop accepting new cookies, how to be notified when you receive a new cookie, how to disable cookies, and when cookies will expire. If you block all cookies on your browser, neither we nor third parties will transmit cookies to your browser. But if you do so, you may have to manually adjust some preferences every time you visit a site and some services and functionalities may not work.
    </p>
    <p>
      For more information about the types of information we collect, please see our <a data-path="termStatement" data-title="PRIVACY_STATEMENT">Privacy Statement</a>.
    </p>
  `
};
